'use client'

import Section from '@lyra/core/components/Section'
import TabsHorizontal from '@lyra/web/components/layout/TabsHorizontal'
import DepthChart from '@lyra/web/containers/common/DepthChart'
import TradingViewChart from '@lyra/web/containers/common/TradingViewChart'
import FundingChart from '@lyra/web/containers/trade/FundingChart'
import TradeFormOrderbookQueryParams from '@lyra/web/containers/trade/TradeFormOrderbookQueryParams'
import { getPerpInstrumentName } from '@lyra/web/utils/instruments'
import { useState } from 'react'

import { MarketId } from '../../../constants/markets'

type Props = {
  marketId: MarketId
}

export default function PerpsPageHelperMobile({ marketId }: Props) {
  const instrumentName = getPerpInstrumentName(marketId)

  const [chartTab, setChartTab] = useState<'price' | 'depth' | 'funding'>('price')

  const chartTabs = [
    {
      onPress: () => setChartTab('price'),
      isSelected: chartTab === 'price',
      name: 'Price',
    },
    {
      onPress: () => setChartTab('depth'),
      isSelected: chartTab === 'depth',
      name: 'Depth',
    },
    {
      onPress: () => setChartTab('funding'),
      isSelected: chartTab === 'funding',
      name: 'Funding',
    },
  ]
  return (
    <>
      <TabsHorizontal
        flex={1}
        borderTopWidth={1}
        borderTopColor="$hairline"
        style={{ overflowX: 'auto' }}
        pages={chartTabs}
      />
      <Section width="100%" height={500}>
        {chartTab === 'price' ? (
          <TradingViewChart currencyId={marketId} height="100%" />
        ) : chartTab === 'depth' ? (
          <DepthChart instrumentName={instrumentName} height="100%" />
        ) : (
          <FundingChart instrumentName={instrumentName} height="100%" />
        )}
      </Section>
      <TradeFormOrderbookQueryParams instrumentName={instrumentName} />
    </>
  )
}
